import { createFileRoute } from '@tanstack/react-router';
import {
  CircleMembersSection,
  CircleOverviewSection,
  circleOverviewField,
} from '@/components/circles/admin/index';
import { GroupVisibilitySection } from '@/components/group/admin/GroupVisibilitySection';
import { GroupArchiveSection } from '@/components/group/admin/GroupArchiveSection';
import { GroupRequestsSection } from '@/components/group/admin/GroupRequestsSection';
import { GroupBroadcastsSection } from '@/components/group/admin/GroupBroadcastsSection';
import { JoinQuestionsSection } from '@/components/group/admin/join-questions';
import { createGroupAdminRoute } from '@/lib/route-factories/group-admin-route';

export const Route = createFileRoute('/_authed/circles/$id/admin/')(
  createGroupAdminRoute({
    kind: 'circle',
    fromId: '/_authed/circles/$id/admin/',
    renderSection: ({ id, section, inviteOpen, field, broadcastStatus, broadcastCursor, session }) => {
      switch (section) {
        case 'overview':
          return <CircleOverviewSection circleId={id} landOnField={circleOverviewField(field)} />;
        case 'visibility':
          return <GroupVisibilitySection id={id} kind="circle" />;
        case 'join-questions':
          return <JoinQuestionsSection groupId={id} kind="circle" />;
        case 'requests':
          return <GroupRequestsSection kind="circle" groupId={id} />;
        case 'members':
          return (
            <CircleMembersSection
              circleId={id}
              viewerUserId={session.userId as string}
              initialInviteOpen={inviteOpen}
            />
          );
        case 'broadcasts':
          return (
            <GroupBroadcastsSection
              kind="circle"
              groupId={id}
              listStatus={broadcastStatus}
              listCursor={broadcastCursor}
            />
          );
        case 'archive':
          return <GroupArchiveSection groupId={id} kind="circle" />;
        // 'circles' is not a section on circle admin; resolveGroupAdminSection
        // would never return it for kind='circle' — but the switch must be
        // exhaustive over GroupAdminSection.
        case 'circles':
          return null;
      }
    },
  }),
);
